import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-dasharray": "1.6 2.2",
      d: "m3.5 16 5-7h6l4 4h8m-23 11 5-7h6l4 4h8"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "m3.5 20 5-7h6l4 4h8" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }